// extracted by mini-css-extract-plugin
var _1 = "HuJLduSFMR_hH7jXZLL8";
export { _1 as "badge" }
